export default {
  orderCheck: `/p/security/orgIncomeSumOrder/orderCheck`, // 小程序提交提现审核
  getOrderIncomdeList: `/p/security/orgIncomeSumOrder/getOrderIncomdeList`, // 获取小程序提交审核
  checkAiNoUserInfo: `/p/security/orgIncomeSumOrder/checkAiNoUserInfo`, // 获取支付宝手机号
  // orderCheck: `${BASE_URL}/p/security/orgIncomeSumOrder/getOrderIncomdeList/orderCheck` // 提现支付宝提交
  getMoudles: `/p/security/cardModuleClassification/list`, // 获取学员PDFs
  deleteModule: '/p/security/cardModuleClassification//delete', // 删除模块
  deleteEbookModule: '/p/security/cardModuleClassificationBook/delete', // 删除模块
  addModule: '/p/security/cardModuleClassification/addOrUpdate', // 添加模块
  addEbookModule: '/p/security/cardModuleClassificationBook/addOrUpdate', // 添加电子数模块
  getDrawDetailPage: '/p/security/stuDrawDetail/getDrawDetailPage', // 学员提现列表
  reviewTheWithdrawal: '/p/security/stuDrawDetail/reviewTheWithdrawal', // 学员提现通过
  rejectTheWithdrawal: '/p/security/stuDrawDetail/rejectTheWithdrawal', // 学员提现不通过
  getEbookMoudles: '/p/security/cardModuleClassificationBook/list', // 职读模块list
  dictJoin: '/p/security/web/dictJoin', // 新增字典表上下级关联
  dictList: '/p/security/web/dict/list', // 新增字典表上下级关联
  dictParentList: '/p/security/web/dict/parentList', // 新增字典表上下级关联
}
